<template>
  <div class="max-w-4xl mx-auto px-6 py-10 text-gray-800">
    <h1 class="text-3xl font-bold mb-8 text-center">Conditions Générales d'Utilisation et de Vente - Professionnels</h1>

    <!-- CGU -->
    <section class="mb-10">
      <h2 class="text-2xl font-semibold mb-4 border-b border-gray-300 pb-2">1. Conditions Générales d'Utilisation (CGU)</h2>

      <p class="mb-4">
        Les présentes Conditions Générales d'Utilisation définissent les modalités d'accès et d'utilisation de la plateforme <strong>BookMySalon</strong> par les professionnels prestataires (ci-après « le Prestataire »).
      </p>

      <h3 class="text-xl font-semibold mt-6 mb-2">1.1. Accès à la plateforme</h3>
      <p>
        Le Prestataire bénéficie d’un accès sécurisé à son espace personnel pour gérer ses services, ses disponibilités, ses rendez-vous et ses clients.
        L’accès est strictement réservé au Prestataire autorisé.
      </p>

      <h3 class="text-xl font-semibold mt-6 mb-2">1.2. Obligations du Prestataire</h3>
      <ul class="list-disc list-inside space-y-1">
        <li>Fournir des informations exactes et à jour lors de l’inscription.</li>
        <li>Respecter les règles d’utilisation et les lois applicables.</li>
        <li>Tenir à jour ses horaires, services et tarifs sur la plateforme.</li>
        <li>Assurer la bonne exécution des prestations réservées via BookMySalon.</li>
        <li>Ne pas utiliser la plateforme à des fins illégales ou frauduleuses.</li>
      </ul>

      <h3 class="text-xl font-semibold mt-6 mb-2">1.3. Responsabilité</h3>
      <p>
        BookMySalon facilite la mise en relation entre Prestataires et clients mais ne peut être tenu responsable des litiges ou désaccords liés aux prestations effectuées.
        La responsabilité du Prestataire est pleine et entière concernant la qualité et l’exécution des services proposés.
      </p>

      <h3 class="text-xl font-semibold mt-6 mb-2">1.4. Suspension ou résiliation</h3>
      <p>
        BookMySalon se réserve le droit de suspendre ou résilier l’accès du Prestataire en cas de non-respect des présentes CGU ou de comportement frauduleux.
      </p>
    </section>

    <!-- CGV -->
    <section>
      <h2 class="text-2xl font-semibold mb-4 border-b border-gray-300 pb-2">2. Conditions Générales de Vente (CGV)</h2>

      <p class="mb-4">
        Les présentes CGV régissent les relations commerciales entre le Prestataire et ses clients réservant via la plateforme <strong>BookMySalon</strong>.
      </p>

      <h3 class="text-xl font-semibold mt-6 mb-2">2.1. Tarification et paiement</h3>
      <ul class="list-disc list-inside space-y-1">
        <li>Les tarifs des prestations sont fixés librement par le Prestataire et affichés sur la plateforme.</li>
        <li>Le paiement peut être effectué en ligne ou directement au salon selon les modalités définies par le Prestataire.</li>
        <li>En cas de paiement en ligne, les transactions sont sécurisées via Stripe.</li>
      </ul>

      <h3 class="text-xl font-semibold mt-6 mb-2">2.2. Acompte et politique d’annulation</h3>
      <p>
        Le Prestataire peut demander un acompte au moment de la réservation. Les conditions de remboursement en cas d’annulation dépendent de la date de celle-ci :
      </p>
      <ul class="list-disc list-inside space-y-1 mb-4">
        <li>Annulation plus de 48h avant la prestation : remboursement intégral de l’acompte.</li>
        <li>Annulation entre 24h et 48h avant la prestation : remboursement partiel (ex. 50%).</li>
        <li>Annulation moins de 24h avant la prestation : aucun remboursement, sauf accord exceptionnel du Prestataire.</li>
      </ul>
      <p>
        Le Prestataire se réserve le droit de modifier cette politique ou de bloquer un client en cas d’annulations répétées ou abusives.
      </p>

      <h3 class="text-xl font-semibold mt-6 mb-2">2.3. Prestations et responsabilité</h3>
      <p>
        Le Prestataire s’engage à fournir les prestations décrites lors de la réservation avec professionnalisme.
        Toute réclamation doit être adressée directement au Prestataire.
        BookMySalon n’est pas responsable des prestations réalisées par le Prestataire.
      </p>

      <h3 class="text-xl font-semibold mt-6 mb-2">2.4. Litiges</h3>
      <p>
        En cas de litige, les parties privilégieront une résolution amiable. À défaut, les tribunaux compétents seront ceux du siège social du Prestataire.
      </p>

      <h3 class="text-xl font-semibold mt-6 mb-2">2.5. Modification des CGV</h3>
      <p>
        BookMySalon se réserve le droit de modifier les présentes CGV. Les Prestataires seront informés des changements via leur espace personnel.
      </p>
    </section>

    <footer class="text-sm text-gray-500 text-center mt-10">
      Dernière mise à jour : 24 juin 2025
    </footer>
  </div>
</template>

<script setup>
// Pas de script nécessaire ici
</script>

<style scoped>
/* Pas de styles personnalisés, tout est en Tailwind */
</style>
